/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ConstantMixin from 'app/mixins/ConstantMixin.js';
import classnames from 'classnames';
import * as IconFactory from 'app/components/common/IconFactory.jsx';
import ShortenerListDetail from 'app/components/ShortenerLists/ShortenerListDetail.jsx';
import * as _ from 'underscore';
import { Breakpoint } from 'react-socks';
import isDefaultShortener from 'app/modules/isDefaultShortener.js';

class ShortenerListItem extends React.Component {
    constructor(props) {
        super(props);

        this.showDetail = this.showDetail.bind(this);
        this.blurRow = this.blurRow.bind(this);

    }

    showDetail() {

        if (this.props.item.id == this.props.detailId) {
            if (this.props.itemType === 'shortener' && this.props.item.ssID) {
                return true;
            } else if (this.props.itemType === 'domain' && !this.props.item.ssID) {
                return true;
            } else if (this.props.itemType === 'shortener' && parseInt(this.props.item.id, 10) === 0) {
                return true;
            }
        }
        return false;
    }

    blurRow() {
        if (this.props.detailId !== null && this.props.item.id != this.props.detailId) {
            return true;
        }
        return false;
    }

    render() {
        let itemClass = classnames(
				'dlvr-list-item',
				{
					'detail': this.showDetail(),
					'blur': this.blurRow()
				}
			),
            Icon = null,
            shortenerDetail = null,
            itemType = (this.props.item.ssID || parseInt(this.props.item.id, 10) === 0) ? 'shortener' : 'domain',
            defaultTag = null,
            name = '\u00a0',
            statusIcon = null,
            reconnectButton = null,
            statusClass = "route-status common",
            constants = this.props.app.config.constants;

        if (this.props.item.ssID) {
            Icon = IconFactory[ConstantMixin.getIconIndexByCode(this.props.item.ssID, 'shortener')];
        } else {
            if (this.props.item.name && this.props.item.name.match(/No Shortener/)) {
                Icon = IconFactory.noShortener;
            } else {
                Icon = IconFactory.customDomain;
            }

        }


        if (this.showDetail()) {
            shortenerDetail = (
                <ShortenerListDetail
                    {...this.props}
                    type={this.props.itemType}
                    detail={this.props.itemDetail}
                    setAsDefault={this.props.setAsDefault}
                    applyToAll={this.props.applyToAll}
                    deleteItem={this.props.deleteItem}
                    updatedCreds={this.props.updatedCreds}
                    reauthHandler={this.props.reauthHandler}
                    errors={this.props.errors}
                    defaultPdId={this.props.defaultPdId}
                    defaultSaId={this.props.defaultSaId} />
            );
        }


        if (isDefaultShortener(this.props.item, this.props.defaultSaId, this.props.defaultPdId)) {
            defaultTag = (
                <div className="default-tag">
                    Default
                </div>
            );
        }

        if (parseInt(this.props.item.errCount, 10) > 0) {
            statusClass += " error";
            statusIcon = <i className="fa fa-exclamation-circle"></i>;
            if (this.props.item.ssID && this.props.item.ssID == constants.SHORTEN_SVC_BITLY) {
                reconnectButton = (
                    <div className="route-status-label">
                        <button className="btn-primary reverse-fixed social-list" onClick={this.props.reauthHandler} data-id={this.props.item.id} data-serviceid={this.props.item.ssID} role="button" aria-label="reconnect">
                            Reconnect
                        </button>
                    </div>
                );
            }
        } else {
            statusClass += " active"
            statusIcon = <i className="fa fa-check-circle"></i>;
            reconnectButton = (
                <div className="route-status-label"></div>
            );
        }

        if (this.props.item.name) {
            name = this.props.item.name;
            if (this.props.item.ssID && this.props.item.ssID > 1) {
                name = ConstantMixin.getShortenServiceByCode(this.props.item.ssID) + " - " + name;
            }
        } else if (this.props.item.domain) {
            name = this.props.item.domain;
        }

        return (
            <li className={itemClass}>
                <div className="list-item-display"
                        onClick={this.props.detailHandler}
                        data-id={this.props.item.id}
                        data-type={itemType}
                        role="switch"
                        aria-label="toggle details">
					<div className="item-type-icon">
                        <Breakpoint desktop only>
						    <Icon/>
                        </Breakpoint>
                        <Breakpoint mobile only>
						    <Icon round={true}/>
                        </Breakpoint>
					</div>
					<div className="item-name common">
						{name}{defaultTag}
					</div>
                    <div className={statusClass}>
						{reconnectButton}
						<div className="route-status-icon">
							{statusIcon}
						</div>
                    </div>
				</div>
                {shortenerDetail}
            </li>
        );
    }

};

ShortenerListItem.displayName = "ShortenerListItem";

ShortenerListItem.propTypes = {
    routeViewType: PropTypes.number,
    item: PropTypes.object,
    itemType: PropTypes.string,
    itemDetail: PropTypes.object,
    detailId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    detailHandler: PropTypes.func,
    setAsDefault: PropTypes.func,
    setShortener: PropTypes.func,
    deleteItem: PropTypes.func,
    updatedCreds: PropTypes.string,
    reauthHandler: PropTypes.func,
    errors: PropTypes.object,
    defaultPdId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    defaultSaId: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ])
};

ShortenerListItem.defaultProps = {
    item: {},
    itemType: '',
    itemDetail: {},
    detailId: null,
    detailHandler: null,
    setAsDefault: null,
    setShortener: null,
    deleteItem: null,
    updatedCreds: '',
    reauthHandler: null,
    errors: null,
    defaultPdId: 0,
    defaultSaId: 0
};

export default ShortenerListItem;
